import { Skeleton } from '@mui/material';
import React from 'react';

export default function Loader() {
  return <Skeleton animation="wave" width="100%" height={50} />;
}
